import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import SelectComponent from './SelectComponent';

import {
  FormGroup,
  Col,
  ControlLabel,
  Button
} from 'react-bootstrap';


export default class BaselineUpdateComponent extends React.Component {
  static propTypes = {
    imageName: PropTypes.string.isRequired,
    jobTypes: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  render() {
    const {
      imageName,
      jobTypes,
      onSubmit
    } = this.props;
    const imageNameList = [];
    imageNameList.push(imageName);
    const initialState = {
      imageName: imageName !== '' ? imageName : '',
      jobType: jobTypes.length !== 0 ? jobTypes[0] : '',
      number: 0
    };

    return (
      <div>
        <LocalForm
          id="baseline-selector-form"
          onSubmit={onSubmit}
          onChange={model => {
            this.setState(
              { ...model }
            ); }
          }
          initialState={initialState}
        >
          <FormGroup>
            <Col md={5}>
              <ControlLabel>
                ImageName
              </ControlLabel>
              <Control.custom
                model=".imageName"
                component={SelectComponent}
                className="form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    options: imageNameList,
                    selected: modelValue.imageName,
                    onChange: onChange
                  };
                }}
              />
            </Col>
            <Col md={3}>
              <ControlLabel>
                Job Types
              </ControlLabel>
              <Control.custom
                model=".jobType"
                component={SelectComponent}
                className="form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    options: jobTypes,
                    selected: modelValue.jobType,
                    onChange: onChange
                  };
                }}
              />
            </Col>
            <Col md={2}>
              <ControlLabel>
                Number
              </ControlLabel>
              <Control
                model=".number"
                className="form-control"
                type="number"
                mapProps={({ modelValue, onChange }) => {
                  return {
                    value: modelValue.number,
                    onChange: onChange
                  };
                }}
              />
            </Col>
            <Col md={2}>
              <ControlLabel>&nbsp;</ControlLabel>
              <Button
                className="form-control"
                type="submit"
                disabled={false}
              >
                Update Baseline
              </Button>
            </Col>
          </FormGroup>
        </LocalForm>
      </div>
    ); }
}


// WEBPACK FOOTER //
// src/Components/BaselineUpdateComponent.jsx